import { Avatar } from '../index';
import React from 'react';

import '../global.less';
import './user.scss';
import { AvatarProps } from 'antd';

export interface UserProps extends AvatarProps {
    name: string;
    profileUrl?: string;
    contact?: string;
}

export default function User(props: UserProps) {
    return (
        <div className="rain-user">
            <Avatar {...props} />
            <div className="rain-user-info">
                <span>{props.name}</span>
                {props.contact && <span className="rain-user-contact">{props.contact}</span>}
            </div>
        </div>
    );
}
